<form role="form" class="form-horizontal entreprise-filters-form">
	<div class="form-group row">
		<label class="col-md-1 control-label">Nom</label>
		<div class="col-md-3">
			<input type="text" id="nom" name="nom" class="form-control" placeholder="Nom" [(ngModel)]="filters.nom" (ngModelChange)="applyFilters()">
		</div>
		
		<label class="col-md-4 control-label">Document applicable</label>
		<div class="col-md-4">
			<label class="radio-inline">
				<input type="radio" name="docApplicable" [value]="'PlanPrevention'" [(ngModel)]="filters.documentApplicable" (ngModelChange)="applyFilters()"> Plan Prevention (Pdp)
			</label>
			<label class="radio-inline">
				<input type="radio" name="docApplicable" [value]="'PersonneAvertie'" [(ngModel)]="filters.documentApplicable" (ngModelChange)="applyFilters()"> Personne Avertie (PA)
			</label>
			<label class="radio-inline">
				<input type="radio" name="docApplicable" [value]="null" [(ngModel)]="filters.documentApplicable" (ngModelChange)="applyFilters()"> Tous
			</label>
		</div>
	</div>
	


	<div class="form-group row">
		<label class="col-md-1 control-label">Actif</label>
		<div class="col-md-2">
			<label class="radio-inline">
				<input type="radio" name="statut" [value]="true" [(ngModel)]="filters.actif" (ngModelChange)="applyFilters()"> Oui
			</label>
			<label class="radio-inline">
				<input type="radio" name="statut" [value]="false" [(ngModel)]="filters.actif" (ngModelChange)="applyFilters()"> Non
			</label>
			<label class="radio-inline">
				<input type="radio" name="statut" [value]="null" [(ngModel)]="filters.actif" (ngModelChange)="applyFilters()"> Tous
			</label>
		</div>
	</div>
	
	<div class="form-group">
		<div class="col-md-2 text-center">
			<button type="button" class="btn btn-primary"
				(click)="resetFilters()">Réinitialiser</button>
		</div>
	</div>
	

</form>